"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
var QueryActionTypes;
(function (QueryActionTypes) {
    QueryActionTypes["LOADING"] = "LOADING";
    QueryActionTypes["SUCCESS"] = "SUCCESS";
    QueryActionTypes["FAIL"] = "FAIL";
})(QueryActionTypes || (QueryActionTypes = {}));
const queryReducer = (state, action) => {
    switch (action.type) {
        case QueryActionTypes.LOADING:
            return Object.assign(Object.assign({}, state), { error: null, loading: true });
        case QueryActionTypes.SUCCESS:
            return Object.assign(Object.assign({}, state), { data: action.payload, loading: false });
        case QueryActionTypes.FAIL:
            return Object.assign(Object.assign({}, state), { error: action.error, loading: false });
        default:
            throw new Error('Undefined action type');
    }
};
const useQuery = (data, siteId, path, afterInit) => {
    const [store, dispatch] = (0, react_1.useReducer)(queryReducer, { loading: !data, data: data });
    (0, react_1.useEffect)(() => {
        if (!data) {
            dispatch({ type: QueryActionTypes.LOADING });
            const url = path.replace(':siteId', siteId.toString());
            fetch(url)
                .then((res) => res.json())
                .then((result) => {
                dispatch({ payload: result, type: QueryActionTypes.SUCCESS });
                if (afterInit)
                    afterInit();
            })
                .catch((err) => {
                dispatch({ error: new Error(err.message), type: QueryActionTypes.FAIL });
            });
        }
    }, [siteId, path]);
    return Object.assign({}, store);
};
exports.default = useQuery;
